import type { MarketVariants } from '@/lib/i18n'

export type Slide13Copy = {
  title: string
  body: string
}

export const copy: MarketVariants<Slide13Copy> = {
  US: {
    title: 'A little training goes a long way.',
    body: 'Once you learn how their tricks work, scammers lose their power.',
  },
  ar: {
    title: 'القليل من التدريب يصنع فرقاً كبيراً.',
    body: 'حين تتعلّم كيف تعمل حيلهم، يفقد المحتالون قوتهم.',
  },
}
